import React from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  return (
    <footer style={{ background: '#050510', borderTop: '2px solid #00f5ff', boxShadow: '0 -4px 30px rgba(0,245,255,0.15)' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-10 md:py-12">
        {/* Main row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-6">
          {/* Brand — full width on mobile */}
          <div className="col-span-2 md:col-span-1 flex flex-col gap-3">
            <div className="flex items-center gap-3">
              <div style={{ width: '44px', height: '44px', border: '2px solid #00f5ff', overflow: 'hidden', flexShrink: 0, boxShadow: '0 0 12px rgba(0,245,255,0.3)' }}>
                <AppImage
                  src="/assets/images/detailing_logo-1786225511155.jpg"
                  alt="Vertex Premium Mobile Detailing logo"
                  width={44}
                  height={44}
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p
                  style={{
                    fontFamily: 'Barlow Condensed, Arial Narrow, Arial, sans-serif',
                    fontWeight: 900,
                    fontSize: '22px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.02em',
                    color: '#e0e8ff',
                    lineHeight: 1,
                    textShadow: '0 0 20px rgba(0,245,255,0.25)',
                  }}
                >
                  VERTEX
                </p>
                <p
                  style={{
                    fontFamily: 'Barlow Condensed, Arial, sans-serif',
                    fontWeight: 700,
                    fontSize: '10px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.16em',
                    color: '#00f5ff',
                    textShadow: '0 0 8px rgba(0,245,255,0.5)',
                  }}
                >
                  PREMIUM MOBILE DETAILING
                </p>
              </div>
            </div>
            <p
              style={{
                fontFamily: 'Barlow Condensed, Arial, sans-serif',
                fontWeight: 600,
                fontSize: '11px',
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                color: 'rgba(224,232,255,0.35)',
              }}
            >
              Mesquite, Nevada
            </p>
          </div>

          {/* Nav links */}
          <div className="flex flex-col gap-2">
            <p
              style={{
                fontFamily: 'Barlow Condensed, Arial, sans-serif',
                fontWeight: 900,
                fontSize: '10px',
                textTransform: 'uppercase',
                letterSpacing: '0.14em',
                color: '#00f5ff',
                marginBottom: '4px',
                textShadow: '0 0 8px rgba(0,245,255,0.5)',
              }}
            >
              Navigate
            </p>
            {[
              { label: 'Services', href: '/home#pricing' },
              { label: 'Pricing', href: '/home#pricing' },
              { label: 'FAQ', href: '/home#faq' },
              { label: 'Book / Waitlist', href: '/home#waitlist' },
            ]?.map((link) => (
              <a
                key={link?.label}
                href={link?.href}
                style={{
                  fontFamily: 'Barlow Condensed, Arial, sans-serif',
                  fontWeight: 700,
                  fontSize: '13px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.08em',
                  color: 'rgba(224,232,255,0.5)',
                  textDecoration: 'none',
                  transition: 'color 0.15s ease',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.color = '#00f5ff')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(224,232,255,0.5)')}
              >
                {link?.label}
              </a>
            ))}
          </div>

          {/* Contact */}
          <div className="flex flex-col gap-2">
            <p
              style={{
                fontFamily: 'Barlow Condensed, Arial, sans-serif',
                fontWeight: 900,
                fontSize: '10px',
                textTransform: 'uppercase',
                letterSpacing: '0.14em',
                color: '#00f5ff',
                marginBottom: '4px',
                textShadow: '0 0 8px rgba(0,245,255,0.5)',
              }}
            >
              Contact
            </p>
            <a
              href="https://www.instagram.com/vertexpremiummobiledetailing"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2"
              style={{
                fontFamily: 'Barlow Condensed, Arial, sans-serif',
                fontWeight: 700,
                fontSize: '13px',
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                color: 'rgba(224,232,255,0.5)',
                textDecoration: 'none',
                transition: 'color 0.15s ease',
              }}
              aria-label="Instagram @vertexpremiummobiledetailing"
              onMouseEnter={(e) => (e.currentTarget.style.color = '#ff00ff')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(224,232,255,0.5)')}
            >
              <Icon name="CameraIcon" size={14} variant="outline" className="shrink-0" style={{ color: 'inherit' }} />
              @vertexpremiummobiledetailing
            </a>
            <a
              href="tel:+17252711448"
              style={{
                fontFamily: 'Barlow Condensed, Arial, sans-serif',
                fontWeight: 700,
                fontSize: '13px',
                textTransform: 'uppercase',
                letterSpacing: '0.06em',
                color: 'rgba(224,232,255,0.5)',
                textDecoration: 'none',
                transition: 'color 0.15s ease',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#00f5ff')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(224,232,255,0.5)')}
            >
              725-271-1448
            </a>
            <a
              href="mailto:envizionary.studios@gmail.com"
              style={{
                fontFamily: 'Barlow Condensed, Arial, sans-serif',
                fontWeight: 600,
                fontSize: '12px',
                letterSpacing: '0.04em',
                color: 'rgba(224,232,255,0.3)',
                textDecoration: 'none',
                transition: 'color 0.15s ease',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#00f5ff')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(224,232,255,0.3)')}
            >
              envizionary.studios@gmail.com
            </a>
          </div>

          {/* Social */}
          <div className="flex flex-col gap-3">
            <p
              style={{
                fontFamily: 'Barlow Condensed, Arial, sans-serif',
                fontWeight: 900,
                fontSize: '10px',
                textTransform: 'uppercase',
                letterSpacing: '0.14em',
                color: '#00f5ff',
                textShadow: '0 0 8px rgba(0,245,255,0.5)',
              }}
            >
              Follow Us
            </p>
            <a
              href="https://www.instagram.com/vertexpremiummobiledetailing"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center"
              style={{
                width: '44px',
                height: '44px',
                background: 'linear-gradient(135deg, #7b2fff 0%, #ff00ff 100%)',
                border: '2px solid rgba(255,0,255,0.4)',
                transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                boxShadow: '0 0 16px rgba(255,0,255,0.3)',
              }}
              aria-label="Instagram @vertexpremiummobiledetailing"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.08)';
                e.currentTarget.style.boxShadow = '0 0 28px rgba(255,0,255,0.6)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 0 16px rgba(255,0,255,0.3)';
              }}
            >
              <Icon name="CameraIcon" size={20} variant="outline" className="text-white" />
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div
          className="mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3"
          style={{ borderTop: '1px solid #1a1a4e' }}
        >
          <span
            style={{
              fontFamily: 'Barlow Condensed, Arial, sans-serif',
              fontWeight: 600,
              fontSize: '11px',
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              color: 'rgba(224,232,255,0.25)',
            }}
          >
            © 2026 Vertex Premium Mobile Detailing
          </span>
          <div className="flex items-center gap-4">
            {[
              { label: 'Privacy Policy', href: '/privacy-policy' },
              { label: 'Terms & Conditions', href: '/terms' },
            ]?.map((link) => (
              <a
                key={link?.label}
                href={link?.href}
                style={{
                  fontFamily: 'Barlow Condensed, Arial, sans-serif',
                  fontWeight: 600,
                  fontSize: '11px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.1em',
                  color: 'rgba(224,232,255,0.25)',
                  textDecoration: 'none',
                  transition: 'color 0.15s ease',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.color = '#00f5ff')}
                onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(224,232,255,0.25)')}
              >
                {link?.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}